import * as React from 'react'

function SvgImpregnationPct(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 4.329 4.329" {...props}>
			<g fill="currentColor">
				<path d="M2.874 1.721a.711.711 0 01-1.422 0c0-.392.711-1.35.711-1.35s.711.958.711 1.35z" />
				<path d="M.82 3.854v-1.01h.38q.1 0 .154.01.074.012.125.047.05.034.08.097.031.063.031.138 0 .129-.082.218-.082.09-.296.09H.953v.41zm.133-.53h.261q.13 0 .184-.048.055-.048.055-.136 0-.063-.033-.108-.032-.046-.084-.06-.034-.009-.125-.009H.953zM2.483 3.5l.133.034q-.042.164-.151.251-.11.086-.267.086-.163 0-.266-.066-.102-.067-.156-.193-.053-.126-.053-.27 0-.158.06-.275.06-.118.172-.179.111-.061.245-.061.152 0 .255.077.103.077.144.217l-.132.031q-.035-.11-.102-.16-.066-.05-.168-.05-.116 0-.195.055-.078.056-.11.15-.03.094-.03.194 0 .129.036.225.038.096.117.143.08.048.172.048.112 0 .19-.065t.106-.192zM3.039 3.854v-.891h-.333v-.12h.8v.12h-.334v.89z" />
			</g>
		</svg>
	)
}

export default SvgImpregnationPct
